var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgTooltipDeleteIcon(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 14,
    height: 14,
    viewBox: "0 0 14 14",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M5.66732 9.66634C5.66732 10.033 5.36732 10.333 5.00065 10.333C4.63398 10.333 4.33398 10.033 4.33398 9.66634V6.99967C4.33398 6.63301 4.63398 6.33301 5.00065 6.33301C5.36732 6.33301 5.66732 6.63301 5.66732 6.99967V9.66634ZM9.66732 9.66634C9.66732 10.033 9.36732 10.333 9.00065 10.333C8.63398 10.333 8.33398 10.033 8.33398 9.66634V6.99967C8.33398 6.63301 8.63398 6.33301 9.00065 6.33301C9.36732 6.33301 9.66732 6.63301 9.66732 6.99967V9.66634ZM11.0007 11.6663C11.0007 12.0337 10.702 12.333 10.334 12.333H3.66732C3.29932 12.333 3.00065 12.0337 3.00065 11.6663V4.33301H11.0007V11.6663ZM5.66732 1.88501C5.66732 1.78167 5.80998 1.66634 6.00065 1.66634H8.00065C8.19132 1.66634 8.33398 1.78167 8.33398 1.88501V2.99967H5.66732V1.88501ZM13.0007 2.99967H12.334H9.66732V1.88501C9.66732 1.02901 8.91998 0.333008 8.00065 0.333008H6.00065C5.08132 0.333008 4.33398 1.02901 4.33398 1.88501V2.99967H1.66732H1.00065C0.633984 2.99967 0.333984 3.29967 0.333984 3.66634C0.333984 4.03301 0.633984 4.33301 1.00065 4.33301H1.66732V11.6663C1.66732 12.769 2.56465 13.6663 3.66732 13.6663H10.334C11.4367 13.6663 12.334 12.769 12.334 11.6663V4.33301H13.0007C13.3673 4.33301 13.6673 4.03301 13.6673 3.66634C13.6673 3.29967 13.3673 2.99967 13.0007 2.99967V2.99967Z",
    fill: "white"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgTooltipDeleteIcon);
export default __webpack_public_path__ + "static/media/tooltipDeleteIcon.23955c8beed1ceeace543550b8721553.svg";
export { ForwardRef as ReactComponent };